 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		15: 0
 	};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		15: 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"0":"styles","1":"18389ac5eacc5ba68c2053858d81c8647af01c3f","2":"f08a028ccab136bf00436aec139f88f0fa019d86","3":"0ce814af0a3dfb2d1442d0ca9204ba375f1a53e0","4":"97c907ce537b7cbdfa41f556182f2750ff685301","5":"c304476c375035fe5ab57f96826d1ad6ff657af5","6":"c05b8182","7":"component---src-pages-layout-js","8":"152025db965c661bb24971169d0795fbb208a411","9":"bf8ae653ceedbcb9aee81fe0aff53ae73c0db6ef","10":"3f985f62e6c52f7e8bc97d6e9a76b184f2711dc4","11":"b9b041f39dc3568dd313b944196020ea562c7d57","12":"bc62dab504a71ef8c5d240a105694d09627f06f3","13":"component---src-pages-integration-builder-sections-code-tsx","14":"d5ceeaead26c68f645dc39122ccc1b9861fd8433","16":"11e8d57d","18":"5cf42e9e","19":"5d19cfc4","20":"962beaf7","22":"component---src-pages-404-js","23":"component---src-pages-banner-js","24":"component---src-pages-build-better-js","25":"component---src-pages-classic-home-js","26":"component---src-pages-docs-template-js","27":"component---src-pages-home-js","28":"component---src-pages-index-js","29":"component---src-pages-integration-builder-index-tsx","30":"component---src-pages-integration-builder-sections-build-tsx","31":"component---src-pages-integration-builder-sections-card-generator-tsx","32":"component---src-pages-integration-builder-sections-configure-tsx","33":"component---src-pages-integration-builder-sections-demo-tsx","34":"component---src-pages-integration-builder-sections-help-modal-tsx","35":"component---src-pages-integration-builder-sections-know-before-you-code-tsx","36":"component---src-pages-integration-builder-sections-preview-tsx","37":"component---src-pages-integration-builder-sections-take-live-tsx","38":"component---src-pages-internal-js","39":"component---src-pages-signup-js","40":"component---src-pages-signupauto-js","41":"component---src-pages-support-js","42":"component---src-pages-thankyou-js","43":"component---src-pages-unsubscribe-js","44":"component---src-pages-video-collection-tsx","45":"component---src-pages-video-home-tsx","46":"component---src-pages-video-watch-tsx","47":"component---src-templates-template-layout-js","48":"d7eeaac4"}[chunkId]||chunkId) + "-" + {"0":"0ec71dd62c66cb95665c","1":"a20e9775fd6710d8e205","2":"1c7b69f213d7c3986414","3":"104e309ac120c3808e52","4":"79841b47e6190bd2d08f","5":"ae3ede589b409e516b37","6":"4f9ac642e755ad751d29","7":"0d9eb1e6df5bdb71daa7","8":"7cd1e3464c069969dada","9":"e52914735deefe8cc47d","10":"8006070df67a9476de1e","11":"d3db10a68fa68e400e52","12":"7a9aea3b5e32945f8eaa","13":"6d73ccad318266aaafe5","14":"359abb871320ed19f0bb","16":"b148735f2c6f6059b0d4","18":"252432597060fb78b9a3","19":"4ef293aaad7356a89338","20":"64f96e656e4bbfea5822","22":"bccc22c3602c4d593a33","23":"81401cc8610c160ea99c","24":"88543bff4541cb366ea3","25":"558198674c55fb2ac740","26":"1cc903a1475027b98be7","27":"d872ae985ac5cbdc99a0","28":"545f6a5b10f36e0922ec","29":"edbc89f72b1808a3c867","30":"de839c2a3ef1c0fab4d1","31":"6723212b7c76c924e1e9","32":"5aba396993df8b90a947","33":"6193c1e14900610ae27e","34":"d5b916f4ceab8beb0680","35":"21cc00c8f670bb28a984","36":"9bb7f3c17e1640535356","37":"93856a3f0af500ff6bb6","38":"a47daa353b6dc4882029","39":"e2c0f9691f68309f7964","40":"e9af48585fea2732a103","41":"18194fb5be863caee44e","42":"717b6c74ec8909b52f82","43":"692ce689515fa2c5e08b","44":"708ad34fec2fab3152a4","45":"622c4adb5783559c3370","46":"64e1809a9d3b80024d32","47":"b9335a9d99e693bbc554","48":"28e2225ad987f5eaf9dc"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"0":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "" + ({"0":"styles","1":"18389ac5eacc5ba68c2053858d81c8647af01c3f","2":"f08a028ccab136bf00436aec139f88f0fa019d86","3":"0ce814af0a3dfb2d1442d0ca9204ba375f1a53e0","4":"97c907ce537b7cbdfa41f556182f2750ff685301","5":"c304476c375035fe5ab57f96826d1ad6ff657af5","6":"c05b8182","7":"component---src-pages-layout-js","8":"152025db965c661bb24971169d0795fbb208a411","9":"bf8ae653ceedbcb9aee81fe0aff53ae73c0db6ef","10":"3f985f62e6c52f7e8bc97d6e9a76b184f2711dc4","11":"b9b041f39dc3568dd313b944196020ea562c7d57","12":"bc62dab504a71ef8c5d240a105694d09627f06f3","13":"component---src-pages-integration-builder-sections-code-tsx","14":"d5ceeaead26c68f645dc39122ccc1b9861fd8433","16":"11e8d57d","18":"5cf42e9e","19":"5d19cfc4","20":"962beaf7","22":"component---src-pages-404-js","23":"component---src-pages-banner-js","24":"component---src-pages-build-better-js","25":"component---src-pages-classic-home-js","26":"component---src-pages-docs-template-js","27":"component---src-pages-home-js","28":"component---src-pages-index-js","29":"component---src-pages-integration-builder-index-tsx","30":"component---src-pages-integration-builder-sections-build-tsx","31":"component---src-pages-integration-builder-sections-card-generator-tsx","32":"component---src-pages-integration-builder-sections-configure-tsx","33":"component---src-pages-integration-builder-sections-demo-tsx","34":"component---src-pages-integration-builder-sections-help-modal-tsx","35":"component---src-pages-integration-builder-sections-know-before-you-code-tsx","36":"component---src-pages-integration-builder-sections-preview-tsx","37":"component---src-pages-integration-builder-sections-take-live-tsx","38":"component---src-pages-internal-js","39":"component---src-pages-signup-js","40":"component---src-pages-signupauto-js","41":"component---src-pages-support-js","42":"component---src-pages-thankyou-js","43":"component---src-pages-unsubscribe-js","44":"component---src-pages-video-collection-tsx","45":"component---src-pages-video-home-tsx","46":"component---src-pages-video-watch-tsx","47":"component---src-templates-template-layout-js","48":"d7eeaac4"}[chunkId]||chunkId) + "." + {"0":"cf9b0f69b63ea95796b1","1":"31d6cfe0d16ae931b73c","2":"31d6cfe0d16ae931b73c","3":"31d6cfe0d16ae931b73c","4":"31d6cfe0d16ae931b73c","5":"31d6cfe0d16ae931b73c","6":"31d6cfe0d16ae931b73c","7":"31d6cfe0d16ae931b73c","8":"31d6cfe0d16ae931b73c","9":"31d6cfe0d16ae931b73c","10":"31d6cfe0d16ae931b73c","11":"31d6cfe0d16ae931b73c","12":"31d6cfe0d16ae931b73c","13":"31d6cfe0d16ae931b73c","14":"31d6cfe0d16ae931b73c","16":"31d6cfe0d16ae931b73c","18":"31d6cfe0d16ae931b73c","19":"31d6cfe0d16ae931b73c","20":"31d6cfe0d16ae931b73c","22":"31d6cfe0d16ae931b73c","23":"31d6cfe0d16ae931b73c","24":"31d6cfe0d16ae931b73c","25":"31d6cfe0d16ae931b73c","26":"31d6cfe0d16ae931b73c","27":"31d6cfe0d16ae931b73c","28":"31d6cfe0d16ae931b73c","29":"31d6cfe0d16ae931b73c","30":"31d6cfe0d16ae931b73c","31":"31d6cfe0d16ae931b73c","32":"31d6cfe0d16ae931b73c","33":"31d6cfe0d16ae931b73c","34":"31d6cfe0d16ae931b73c","35":"31d6cfe0d16ae931b73c","36":"31d6cfe0d16ae931b73c","37":"31d6cfe0d16ae931b73c","38":"31d6cfe0d16ae931b73c","39":"31d6cfe0d16ae931b73c","40":"31d6cfe0d16ae931b73c","41":"31d6cfe0d16ae931b73c","42":"31d6cfe0d16ae931b73c","43":"31d6cfe0d16ae931b73c","44":"31d6cfe0d16ae931b73c","45":"31d6cfe0d16ae931b73c","46":"31d6cfe0d16ae931b73c","47":"31d6cfe0d16ae931b73c","48":"31d6cfe0d16ae931b73c"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "https://www.paypalobjects.com/ppdevdocs/v2noapi/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
